// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1731556f","155":"65f148b2","341":"8eafaa85","811":"2a7f2472","825":"089063d7"}[chunkId] + ".chunk.js";
};